module.exports = __webpack_public_path__ + "img/sprachenanzahl.5bf9d3a1.svg";